<template>
  <div id="app">
    <SideNavigation />
    <Header  />
    <div class="content-container" :class="{ open: isMenuOpen }">
      <router-view />
    </div>
    <ModalRoot />
    <Notification />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Bus } from "./eventBus";
import authentication from "./authentication/";

export default {
  name: "App",
  components: {
    Header: () =>
      import(/* webpackPrefetch: true */ "./components/header/Header"),
    SideNavigation: () =>
      import(/* webpackPrefetch: true */ "./components/sidenav/SideNavigation"),
    ModalRoot: () =>
      import(/* webpackPrefetch: true */ "./components/modal-root/ModalRoot"),
    Notification: () =>
      import(/* webpackPrefetch: true */ "./components/common/Notification"),
  },
  data: () => ({
    statusApi: "FormulationMapping/GetFormulationStatus",
  }),
  created() {
    console.log(
      `Working on '${process.env.NODE_ENV}' mode @ ${process.env.VUE_APP_API_URL} -- `
    );
    this.fetchUserRole();
    this.fetchStatus();
  },
    computed: {
    ...mapGetters({
      isMenuOpen: "GET_IS_MENU_OPEN",
    }),
  },
  methods: {
    ...mapActions({
      updateStatus: "fetchStatus",
      updateUserRole: "fetchUserRole",
    }),
    async fetchUserRole() {
      try {
        const { data } = await this.$http
          .get(
            `${
              process.env.VUE_APP_API_URL
            }/FormulationMapping/GetLoginUserDetail/${authentication.getUserEmail()}`
          )
          .catch((error) => {
            Bus.$emit("notification", {
              text: error,
              type: "error",
            });
          });
        const userInfo = {
          role: data.length === 0 ? "" : data[0].Role_Name,
          userCountries: data.length === 0 ? "" : data[0].UserCountries,
          isUserAccess: data.length === 0 ? false : true,
          isUser:
            data.length === 0
              ? ""
              : data[0].Role_Name === "User" || data[0].Role_Name === "Admin"
              ? true
              : false,
        };
        this.updateUserRole(userInfo);
        if (!userInfo.isUserAccess) {
          this.$router.push({ name: "unauthorised" }).catch(() => {});
        }
      } catch (error) {
        console.log("error: ", error);
        Bus.$emit("notification", {
          text: error,
          type: "error",
        });
      }
    },
    async fetchStatus() {
      try {
        const { data } = await this.$http
          .get(`${process.env.VUE_APP_API_URL}/${this.statusApi}`)
          .catch((error) => {
            Bus.$emit("notification", {
              text: error,
              type: "error",
            });
          });
        this.updateStatus(data);
      } catch (error) {
        console.log("error: ", error);
        Bus.$emit("notification", {
          text: error,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-container {
  transition: margin-left 0.5s;
}
.content-container.open {
  transition: margin-left 0.5s;
  // margin-left: 230px;
}
</style>
